import ServiceLogEntry from 'components/DroneDetailsDrawer/components/DroneServiceLogTab/components/ServiceLogEntry';
import Timeline from 'components/Timeline';
import SkeletonText from 'components/loaders/SkeletonText';
import CaptionText from 'components/text/CaptionText';

import useTranslation from './hooks/useTranslation';

import { SKELETON_LINES, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const ServiceLogHistory: FunctionComponent<Props> = ({
    entries,
    isLoading = false,
    testId = TEST_ID
}) => {
    const { NO_SERVICE_LOGGED } = useTranslation();

    if (isLoading) {
        return <SkeletonText lines={SKELETON_LINES} testId={testId} />;
    }

    if (entries.length === 0) {
        return <CaptionText testId={testId} text={NO_SERVICE_LOGGED} />;
    }

    return (
        <Timeline testId={testId}>
            {entries.map(entry => (
                <ServiceLogEntry
                    eventType={entry.eventType}
                    key={entry.id}
                    modelNumber={entry.modelNumber}
                    notes={entry.notes}
                    partLabel={entry.partLabel}
                    performedAt={entry.performedAt}
                    performedBy={entry.performedBy}
                />
            ))}
        </Timeline>
    );
};

export default ServiceLogHistory;
